import React, { useState, useEffect } from 'react';
import DisplayModal from '../../Modal/DisplayModal';
import { useDispatch, useSelector } from "react-redux";
import { Box } from '@mui/material';
// utilities
import { 
  setModules,
  setFormData,
} from "../../../features/roleStepper/roleStepperSlice";
import { getRoleDetails } from '../../../utils/api/role_apis';
import { STATUS } from '../../../utils/api/sharedfunction';
// components
import RoleDisplayContainer from './RoleDisplayContainer';
import TextSkeletonContainer from '../../Skeleton/TextSkeletonContainer';


// Utility function to format permission data (selected)
const formatPermissionData = (data) => {
  return data.reduce((acc, mod) => {
    acc[mod.categoryId] = {
      left: [],
      right: mod.permissionData,
      moduleName: mod.moduleName,
    };
    return acc;
  }, {});
};

// Utility function to format the roleDetails into the desired payload structure
const formatRoleDetailsToPayload = (roleDetails) => {
  return {
    name: roleDetails.name,
    description: roleDetails.description,
    type: roleDetails.scope,
  };
};


const RoleDisplayModal = ({ name, open, onClose, roleData }) => {
  
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const scopeType = useSelector((state) => state.roleStepper.roleType);
  const roleId = useSelector((state) => state.roleStepper.selectedRoleID);
  
  useEffect(() => {
    if (!open) return;
    fetchRoleDetails();
  }, [open, dispatch]);

  const fetchRoleDetails = async () => {
    try {
      setIsLoading(true);
      const roleDetailsRes = await getRoleDetails(scopeType, roleId);

      if (roleDetailsRes.status === STATUS.SUCCESS) {
        const roleDetails = roleDetailsRes.data.roleDetails;
        const selectedPermissions = roleDetailsRes.data.permissions;

        // Format the role and permission data
        const formattedRoleDetails = formatRoleDetailsToPayload(roleDetails);
        const formattedPermissions = formatPermissionData(selectedPermissions);

        dispatch(setModules(formattedPermissions));
        dispatch(setFormData(formattedRoleDetails));
      } else {
        console.error("Failed to fetch permission modules:", roleDetailsRes.error);
      }
    } catch (error) {
      console.error("Failed to fetch permission modules:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const skelitonLoading = () => {
    return (
      <Box sx={{ p: 3 }}>
        <TextSkeletonContainer width="80%" height={30} lines={5} />
      </Box>
    );
  };

  return (
    <DisplayModal open={open} onClose={onClose} name={name}>
      {isLoading ? (
        skelitonLoading()
      ) : (
        <RoleDisplayContainer />
      )}
    </DisplayModal>
  );
};

export default RoleDisplayModal;
